export const GetUserDetailsByToken = (token) => {
  return fetch(
    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`,
    {
      method: "GET",
      mode: "cors",
    }
  )
    .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
    .then((obj) => {
      return obj;
    });
};
